if (!customElements.get('cb-acoustic-guide')) {
  customElements.define('cb-acoustic-guide', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      this.dataset.ready = 'true';
      const values = [0.15, 0.5, 1, 1, 1, 0.95];
      const format = new Intl.NumberFormat(this.lang || 'sv', {minimumFractionDigits: 2, maximumFractionDigits: 2});
      this.querySelectorAll('[data-mode]').forEach(button => button.addEventListener('click', () => {
        const alpha = button.dataset.mode === 'alpha';
        this.querySelectorAll('[data-value]').forEach((el, i) => { el.textContent = alpha ? format.format(values[i]) : Math.round(values[i] * 100) + ' %'; });
        ['high', 'mid', 'low'].forEach((key, i) => { this.querySelector('[data-axis="' + key + '"]').textContent = alpha ? format.format([1, 0.5, 0][i]) : [100, 50, 0][i] + ' %'; });
        this.querySelectorAll('[data-mode]').forEach(el => el.setAttribute('aria-pressed', String(el === button)));
      }));
      const dialog = this.querySelector('dialog');
      const buttons = [...this.querySelectorAll('[data-gallery]')];
      let index = 0;
      let opener;
      const show = n => {
        index = (n + buttons.length) % buttons.length;
        const source = buttons[index].querySelector('img');
        const img = dialog.querySelector('img');
        img.removeAttribute('srcset');
        img.src = source.src.replace(/([?&])width=\d+/, '$1width=2000');
        img.alt = buttons[index].querySelector('span').textContent;
        img.width = source.width;
        img.height = source.height;
        dialog.querySelector('.gallery-caption').textContent = img.alt + ' · ' + (index + 1) + ' / ' + buttons.length;
      };
      buttons.forEach((button, i) => button.addEventListener('click', () => { opener = button; show(i); dialog.showModal(); dialog.querySelector('.gallery-close').focus(); }));
      dialog.querySelector('.gallery-close').addEventListener('click', () => dialog.close());
      dialog.querySelector('[data-prev]').addEventListener('click', () => show(index - 1));
      dialog.querySelector('[data-next]').addEventListener('click', () => show(index + 1));
      dialog.addEventListener('close', () => opener?.focus());
      dialog.addEventListener('keydown', event => {
        if (event.key === 'ArrowLeft') {event.preventDefault();show(index - 1);}
        if (event.key === 'ArrowRight') {event.preventDefault();show(index + 1);}
      });
    }
  });
}
